import { render, staticRenderFns } from "./newDevReport.vue?vue&type=template&id=241950bc"
import script from "./newDevReport.vue?vue&type=script&lang=js"
export * from "./newDevReport.vue?vue&type=script&lang=js"
import style0 from "./newDevReport.vue?vue&type=style&index=0&id=241950bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports